<app-shared-dialog
  [title]="titleKey | translate"
  [options]="{
    hideHeader: true,
    hideCloseButton: true,
    customConfirmButton: true,
    size: 'medium'
  }">
  <div class="inbox-disconnect">
    <span class="inbox-disconnect__title">
      <ui-icon name="Unlink" size="large"></ui-icon>
      {{ titleKey | translate }}
    </span>
    <p class="inbox-disconnect__description">
      {{ 'smart_inbox.disconnect_dialog.description' | translate: { email: data.email } }}
    </p>

    <!-- Radio rather than a button per option: the confirm button then names the
         outcome, and the destructive path needs a deliberate select-then-confirm. -->
    <mat-radio-group class="inbox-disconnect__choices" [ngModel]="choice" (ngModelChange)="select($event)">
      <label class="inbox-disconnect__choice"
             *ngIf="data.canDisconnect"
             [class.inbox-disconnect__choice--selected]="choice === 'disconnect_only'">
        <mat-radio-button value="disconnect_only"></mat-radio-button>
        <span class="inbox-disconnect__choice-text">
          <span class="inbox-disconnect__choice-label">
            {{ 'smart_inbox.disconnect_dialog.disconnect_only' | translate }}
          </span>
          <span class="inbox-disconnect__choice-hint">
            {{ 'smart_inbox.disconnect_dialog.disconnect_only_hint' | translate }}
          </span>
        </span>
      </label>

      <label class="inbox-disconnect__choice inbox-disconnect__choice--danger"
             *ngIf="data.canDelete"
             [class.inbox-disconnect__choice--selected]="choice === 'delete_connection'">
        <mat-radio-button value="delete_connection" color="warn"></mat-radio-button>
        <span class="inbox-disconnect__choice-text">
          <span class="inbox-disconnect__choice-label">
            {{ 'smart_inbox.disconnect_dialog.delete_connection' | translate }}
          </span>
          <span class="inbox-disconnect__choice-hint">
            {{ 'smart_inbox.disconnect_dialog.delete_connection_hint' | translate }}
          </span>
        </span>
      </label>
    </mat-radio-group>

    <p class="inbox-disconnect__owner-note" *ngIf="!data.canDelete">
      {{ 'smart_inbox.disconnect_dialog.delete_owner_only' | translate }}
    </p>
  </div>

  <div customConfirm class="inbox-disconnect__actions">
    <ui-button
      type="transparent"
      [label]="'common.cancel' | translate"
      (click)="cancel()">
    </ui-button>
    <ui-button
      [type]="isDestructive ? 'danger' : 'secondary'"
      [lucideIcon]="isDestructive ? 'Trash2' : 'Unlink'"
      iconSize="medium"
      [label]="confirmLabelKey | translate"
      (click)="confirm()">
    </ui-button>
  </div>
</app-shared-dialog>
